<script>
  import { BTab } from 'bootstrap-vue'
  
  export default {
    name: 'UiTab',
    components: {
      BTab,
    },
  }
</script>

<template>
  <BTab v-bind="$attrs">
    <template v-slot:title>
      <slot name="title"></slot>
    </template>
    <slot></slot>
  </BTab>
</template>